module.exports = __webpack_public_path__ + "static/media/baccarat.2d77bbe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/baccarat.png
// module id = 2393
// module chunks = 7